/**
 * Check whether value fulfills criteria
 * @param {String} relationValue
 * @param {Array|String} valueList
 * @returns {Boolean}
 */
function checkRelation(relationValue, valueList) {
	const testValue = Array.isArray(valueList) ? valueList : [valueList];
	const isNegative = !!(testValue[0] && testValue[0].match(/!/));
	const show = isNegative
		? (relationValue === '' && testValue[0] !== '!') ||
		  testValue.indexOf('!' + relationValue) === -1
		: relationValue !== '' && testValue[0] !== '' && testValue.indexOf(relationValue) !== -1;

	return show;
}

/**
 * Check whether `accountType` fulfills requirements for `visibility`
 * @params {Object} options
 * @params {Array|String} options.visibility
 * @params {String} [options.accountType='visitor']
 * @returns {Boolean}
 */
function checkAccessRights(options) {
	if (options.visibility === 'all') {
		return true;
	}

	const accountType = options.accountType || 'visitor';
	const isAllowed = checkRelation(accountType, options.visibility);

	return isAllowed;
}

module.exports = {
	checkRelation,
	checkAccessRights
};
